import React from "react";

import {Button} from "@pg-design/button-module";
import {BrandWeightIcon, CheckIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";

import {useFavourites} from "../../favorite/hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../../favorite/tracking/favourite_gtm_events";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites} = useFavourites();

    const isInFavourites = isPropertyInFavourites(propertyId);

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Popover isActive body={<div>Dodaj nieruchomość aby skorzystać z porównywarki</div>} popoverPlace="left" toggleHoverHandlers toggleBlurHandler>
            <Button
                variant={theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
                size="small"
                iconLeft={isInFavourites ? CheckIcon : BrandWeightIcon}
                onClick={onFavouriteToggle}
                className={className}
            >
                {isInFavourites ? "Dodano do porównania" : "Dodaj do porównania"}
            </Button>
        </Popover>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {BrandWeightIcon, CheckIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";

import {useFavourites} from "../../favorite/hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../../favorite/tracking/favourite_gtm_events";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites} = useFavourites();

    const isInFavourites = isPropertyInFavourites(propertyId);

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Popover isActive body={<div>Dodaj nieruchomość aby skorzystać z porównywarki</div>} popoverPlace="left" toggleHoverHandlers toggleBlurHandler>
            <Button
                variant={theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
                size="small"
                iconLeft={isInFavourites ? CheckIcon : BrandWeightIcon}
                onClick={onFavouriteToggle}
                className={className}
            >
                {isInFavourites ? "Dodano do porównania" : "Dodaj do porównania"}
            </Button>
        </Popover>
    );
};
